// extracted by mini-css-extract-plugin
export var circle = "_dv-1";
export var exitConfirmationModal = "_dv-5";
export var iframe = "_dv-0";
export var offline = "_dv-3";
export var online = "_dv-2";
export var workstationSelectError = "_dv-4";